export const experiences = [
    {
      id: 1,
      duration: "Sept. 2025 - Feb. 2026",
      title: "Software Engineer | Founding Engineer",
      company: "Pausa",
    },
    {
      id: 2,
      duration: "Jun. 2025 - Aug. 2025",
      title: "Software Engineer Intern",
      company: "Pausa",
    },
    {
      id: 3,
      duration: "Mar. 2024 - Dec. 2024",
      title: "Strategy Consultant",
      company: "Oliver Wyman",
    },
    {
      id: 4,
      duration: "Aug. 2022 - Jan. 2023",
      title: "Strategy Consultant Intern",
      company: "Oliver Wyman",
    },
];
  